import { LoanRepaymentTemplate } from "@/modules/template/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const LoanRepaymentTemplatePage = ({ isEdit }: IOperationPageProps) => (
  <LoanRepaymentTemplate isEdit={isEdit}/>
);
